import DOMPurify from "dompurify";
import isEmpty from "lodash/isEmpty";

import {Alert} from "@/components/alert/Alert.tsx";
import {PropsWithClassName} from "@/lib/types/props.ts";

interface FormErrorAlertsProps extends PropsWithClassName {
  errors: string[];
}

const FormErrorAlerts = ({errors, className}: FormErrorAlertsProps) => {
  if (isEmpty(errors)) {
    return null;
  }
  const sanitizedErrors = errors.map((error) => DOMPurify.sanitize(error));
  const alertBody =
    sanitizedErrors.length === 1 ? (
      <div dangerouslySetInnerHTML={{__html: sanitizedErrors[0]}} />
    ) : (
      sanitizedErrors.map((error: string, index: number) => (
        <li key={index} dangerouslySetInnerHTML={{__html: error}} />
      ))
    );
  return <Alert className={className ? className : "mb-0"} children={alertBody} variant="error" />;
};

export default FormErrorAlerts;
